// ! AUTO-GENERATED FILE
// ! DO NOT TOUCH !!!

// #pause-sonar#
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { ApiConfiguration } from '../api-configuration';
import { BaseService } from '../base-service';
import { Models } from '../models/models';
import { MostAffineModel } from '../models/most-affine-model';
import { RequestBuilder } from '../request-builder';
import { StrictHttpResponse } from '../strict-http-response';

/**
 * Get values for customer affinity with MB score
 */
@Injectable({
  providedIn: 'root'
})
export class AffinityService extends BaseService {
  public constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `recommendedModel()` */
  static readonly RecommendedModelPath = '/api/v3/{market}/{subProcess}/{dataVersion}/affinity/model';

  /**
   * Returns the most-selling match to given MBScore Input.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `recommendedModel$Json()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  recommendedModel$Json$Response(
    params: {
      market: string;
      subProcess: string;
      dataVersion: string;
      'x-owcc-appversion'?: string;
      'x-owcc-usergroup'?: string;
      'x-owcc-saleslevel'?: string;
      'x-owcc-configurationdate'?: string;
      'x-owcc-zipcode'?: string;
      'x-owcc-carllabel'?: string;
      'x-owcc-formattingtag'?: string;
      'X-B2XCORE_AUTHENTICATION'?: string;

      /**
       * vehicle model ids and affinity score from which the best matching is returned
       */
      body: Models;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<MostAffineModel>> {
    const rb = new RequestBuilder(this.rootUrl, AffinityService.RecommendedModelPath, 'post');
    if (params) {
      rb.path('market', params.market, {});
      rb.path('subProcess', params.subProcess, {});
      rb.path('dataVersion', params.dataVersion, {});
      rb.header('x-owcc-appversion', params['x-owcc-appversion'], {});
      rb.header('x-owcc-usergroup', params['x-owcc-usergroup'], {});
      rb.header('x-owcc-saleslevel', params['x-owcc-saleslevel'], {});
      rb.header('x-owcc-configurationdate', params['x-owcc-configurationdate'], {});
      rb.header('x-owcc-zipcode', params['x-owcc-zipcode'], {});
      rb.header('x-owcc-carllabel', params['x-owcc-carllabel'], {});
      rb.header('x-owcc-formattingtag', params['x-owcc-formattingtag'], {});
      rb.header('X-B2XCORE_AUTHENTICATION', params['X-B2XCORE_AUTHENTICATION'], {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MostAffineModel>;
      })
    );
  }

  /**
   * Returns the most-selling match to given MBScore Input.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `recommendedModel$Json$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  recommendedModel$Json(
    params: {
      market: string;
      subProcess: string;
      dataVersion: string;
      'x-owcc-appversion'?: string;
      'x-owcc-usergroup'?: string;
      'x-owcc-saleslevel'?: string;
      'x-owcc-configurationdate'?: string;
      'x-owcc-zipcode'?: string;
      'x-owcc-carllabel'?: string;
      'x-owcc-formattingtag'?: string;
      'X-B2XCORE_AUTHENTICATION'?: string;

      /**
       * vehicle model ids and affinity score from which the best matching is returned
       */
      body: Models;
    },
    context?: HttpContext
  ): Observable<MostAffineModel> {
    return this.recommendedModel$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<MostAffineModel>): MostAffineModel => r.body)
    );
  }

  /**
   * Returns the most-selling match to given MBScore Input.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `recommendedModel$Plain()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  recommendedModel$Plain$Response(
    params: {
      market: string;
      subProcess: string;
      dataVersion: string;
      'x-owcc-appversion'?: string;
      'x-owcc-usergroup'?: string;
      'x-owcc-saleslevel'?: string;
      'x-owcc-configurationdate'?: string;
      'x-owcc-zipcode'?: string;
      'x-owcc-carllabel'?: string;
      'x-owcc-formattingtag'?: string;
      'X-B2XCORE_AUTHENTICATION'?: string;

      /**
       * vehicle model ids and affinity score from which the best matching is returned
       */
      body: Models;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<MostAffineModel>> {
    const rb = new RequestBuilder(this.rootUrl, AffinityService.RecommendedModelPath, 'post');
    if (params) {
      rb.path('market', params.market, {});
      rb.path('subProcess', params.subProcess, {});
      rb.path('dataVersion', params.dataVersion, {});
      rb.header('x-owcc-appversion', params['x-owcc-appversion'], {});
      rb.header('x-owcc-usergroup', params['x-owcc-usergroup'], {});
      rb.header('x-owcc-saleslevel', params['x-owcc-saleslevel'], {});
      rb.header('x-owcc-configurationdate', params['x-owcc-configurationdate'], {});
      rb.header('x-owcc-zipcode', params['x-owcc-zipcode'], {});
      rb.header('x-owcc-carllabel', params['x-owcc-carllabel'], {});
      rb.header('x-owcc-formattingtag', params['x-owcc-formattingtag'], {});
      rb.header('X-B2XCORE_AUTHENTICATION', params['X-B2XCORE_AUTHENTICATION'], {});
      rb.body(params.body, 'text/plain');
    }

    return this.http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MostAffineModel>;
      })
    );
  }

  /**
   * Returns the most-selling match to given MBScore Input.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `recommendedModel$Plain$Response()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  recommendedModel$Plain(
    params: {
      market: string;
      subProcess: string;
      dataVersion: string;
      'x-owcc-appversion'?: string;
      'x-owcc-usergroup'?: string;
      'x-owcc-saleslevel'?: string;
      'x-owcc-configurationdate'?: string;
      'x-owcc-zipcode'?: string;
      'x-owcc-carllabel'?: string;
      'x-owcc-formattingtag'?: string;
      'X-B2XCORE_AUTHENTICATION'?: string;

      /**
       * vehicle model ids and affinity score from which the best matching is returned
       */
      body: Models;
    },
    context?: HttpContext
  ): Observable<MostAffineModel> {
    return this.recommendedModel$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<MostAffineModel>): MostAffineModel => r.body)
    );
  }
}
// #continue-sonar#
